import * as React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Dashboard from '../../../components/Admin/Dashboard.js';
import { useState, useEffect } from 'react';
import { Styles } from '../../../styles/global.js';
import { getAssignemnts } from '../../../utils/API.js';
import 'chart.js/auto';

import { Chip } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import EditModal from '../../../components/Assignments/EditModal.js';
import {
  ModalProvider,
  useModal,
} from '../../../components/Assignments/ModalContext.js';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';

ModuleRegistry.registerModules([AllCommunityModule]);

function getAssignmentTable(assignments) {
  if (!assignments || !assignments?.length) {
    return undefined;
  }
  function determineCompettion(assignment) {
    const competition = assignment.rubricCopy.type;
    if (competition === 'BestInCollege') {
      return 'Best In College';
    }
    if (competition === 'Department') {
      return 'Best In Department';
    }
    if (competition === 'Innovation') {
      return 'Innovation';
    }
    if (competition === 'Other') {
      return 'Other';
    }
    return 'Unknown';
  }
  return assignments?.map((assignment) => {
    return {
      id: assignment._id,
      judge: assignment.judgeDetails.fullName,
      competiton: determineCompettion(assignment),
      project: assignment.projectDetails.title,
      course: assignment.projectDetails.course,
      department: assignment.projectDetails.department,
      status: assignment.status,
      scores: assignment.scores?.join(', ') || '',
      final: assignment.aggregateScore || '',
      contact: assignment.judgeDetails.phoneNumber || '',
      raw: assignment,
    };
  });
}

function ViewAssignemnts({ assignments, setAssignments }) {
  const { setAssignment, openModal } = useModal();

  const agColumns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 50,
      sortable: true,
      filter: 'agNumberColumnFilter',
    },
    {
      field: 'judge',
      headerName: 'Judge',
      width: 100,
      sortable: true,
      filter: 'agTextColumnFilter',
    },
    {
      field: 'contact',
      headerName: 'Contact',
      width: 100,
      filter: 'agTextColumnFilter',
    },
    {
      field: 'competiton', // fixed typo from 'competiton'
      headerName: 'Competition',
      width: 150,
      filter: 'agTextColumnFilter',
    },
    {
      field: 'project',
      headerName: 'Project',
      width: 130,
      filter: 'agTextColumnFilter',
    },
    {
      field: 'course',
      headerName: 'Course',
      width: 100,
      filter: 'agTextColumnFilter',
    },
    {
      field: 'department',
      headerName: 'Dept',
      width: 100,
      filter: 'agTextColumnFilter',
    },
    {
      field: 'status',
      headerName: 'Completion',
      width: 150,
      filter: 'agTextColumnFilter',
      cellRenderer: (params) => {
        const status = params.value;
        return (
          <Chip
            label={status}
            color={status === 'PENDING' ? 'warning' : 'success'}
          />
        );
      },
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: {
        values: ['PENDING', 'COMPLETED'],
      },
    },
    {
      field: 'scores',
      headerName: 'Scores',
      filter: 'agNumberColumnFilter',
    },
    {
      field: 'final',
      headerName: 'Final',
      width: 70,
      flex: 1,
      filter: 'agNumberColumnFilter',
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 100,
      sortable: false,
      filter: false,
      cellRenderer: (params) => {
        return (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            style={{ width: '100%', height: '100%' }}
          >
            <MoreVert
              style={{ cursor: 'pointer' }}
              onClick={() => {
                // This is your click handler
                console.log('Row clicked:', params.data);
                setAssignment(params.data.raw); // your modal logic
                openModal();
              }}
            />
          </Box>
        );
      },
    },
  ];

  const transformedAssignments = getAssignmentTable(assignments);

  return (
    !!transformedAssignments && (
      <>
        <EditModal />
        {/* <DataGrid
          rows={transformedAssignments}
          columns={columns}
          initialState={{ pagination: { paginationModel } }}
          pageSizeOptions={[10, 25, 50, 100]}
          sx={{
            height: 500, // Ensure it has a height
            border: '1px solid #ddd',
            borderRadius: 2,
            overflow: 'hidden',
            '& .MuiDataGrid-columnHeaders': {
              fontSize: '1rem',
              fontWeight: 'bold',
            },
            '& .MuiDataGrid-root': {
              backgroundColor: 'white',
            },
            '& .MuiDataGrid-cell': {
              fontSize: '0.9rem',
              borderBottom: '1px solid #eee',
            },
            '& .MuiDataGrid-row:nth-of-type(even)': {
              backgroundColor: '#f4f4f4',
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#e3f2fd',
            },
          }}
          checkboxSelection={false}
          isRowSelectable={false}
          disableRowSelectionOnClick
          slots={{ toolbar: GridToolbar }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 300 },
            },
          }}
          filterModel={filterModel}
          onFilterModelChange={(newModel) => setFilterModel(newModel)}
        /> */}
        <div style={{ height: 600 }}>
          <AgGridReact
            rowData={transformedAssignments}
            columnDefs={agColumns}
            defaultColDef={{
              sortable: true,
              filter: true,
              resizable: true,
            }}
            pagination={true}
            paginationPageSize={10}
            getRowStyle={(params) => {
              if (params.node.rowIndex % 2 === 0) {
                return { backgroundColor: '#f4f4f4' };
              }
              return null;
            }}
          />
        </div>
      </>
    )
  );
}

function Assignments() {
  let [assignments, setAssignments] = useState({});
  useEffect(() => {
    async function fetchData() {
      try {
        const assignments = await getAssignemnts(
          'year=' + new Date().getFullYear(),
        );
        setAssignments(assignments?.data?.data);
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, []);
  return (
    <>
      <Box {...Styles.mainBox}>
        <Toolbar />

        {/* Container With Max Width = lg breakpoint */}
        <Container {...Styles.customContainer('xl')}>
          {/*Outer Grid Container */}
          <Grid container spacing={3}>
            {/*Inner Grid Begins*/}

            {/*Inner Grid Item 1: Page Title */}
            <Grid item lg={12} sm={12} xs={12}>
              <Paper {...Styles.dashboardPageWidget()}>Judge Assignments</Paper>
            </Grid>

            {/*Inner Grid Item 2:  View Deadline Config */}
            <Grid item lg={12} sm={12} xs={12}>
              <Paper {...Styles.dashboardContentWidget('auto')}>
                <ModalProvider>
                  <ViewAssignemnts
                    assignments={assignments}
                    setAssignments={setAssignments}
                  />
                </ModalProvider>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}

export default function AdminDashboardAssignments() {
  return (
    <Dashboard Page={Assignments} PageName="(A) Dashboard - Judge Assigments" />
  );
}
